import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<BrowserError />",{ moduleName: "adcdriver/templates/browser.hbs" })